import { GroupSystem, PoolSystem, Scene } from '@goodboydigital/odie';
import type { Container } from 'pixi.js';

import { Entity25D } from './Entity25D';
import { View25DSystem } from './View25DSystem';

export class Scene25D extends Scene
{
    public pool: PoolSystem;
    public group: GroupSystem<Entity25D>;
    public view25d: View25DSystem;

    constructor(container: Container)
    {
        super();
        this.pool = this.addSystem(PoolSystem, {});
        this.group = this.addSystem<null, GroupSystem<Entity25D>>(GroupSystem as any);
        this.view25d = this.addSystem(View25DSystem as any, { stage: container });
    }

    public addChild(...entities: Entity25D[]): void
    {
        for (let i = 0; i < entities.length; i++)
        {
            const entity = entities[i];

            this.addToScene(entity);
        }
    }

    public removeChild(...entities: Entity25D[]): void
    {
        for (let i = 0; i < entities.length; i++)
        {
            const entity = entities[i];

            this.removeFromScene(entity);
        }
    }
}
